"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontierTown = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
const Tags_1 = require("../Tags");
const Units_1 = require("../../Units");
const Turmoil_1 = require("../../turmoil/Turmoil");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const HellasBoard_1 = require("../../boards/HellasBoard");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const SpaceBonus_1 = require("../../SpaceBonus");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const VastitasBorealisBoard_1 = require("../../boards/VastitasBorealisBoard");
const TileType_1 = require("../../TileType");
class FrontierTown extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.FRONTIER_TOWN,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 11,
            productionBox: Units_1.Units.of({ energy: -1 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.MARS)),
            metadata: {
                cardNumber: 'P74',
                description: 'Requires that Mars First are ruling or that you have 2 delegates there. Decrease your energy production 1 step. Place a city tile. GAIN THE PRINTED PLACEMENT BONUS 2 ADDITIONAL TIMES.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.minus().energy(1)).city().asterix();
                }),
            },
        });
    }
    canPlay(player) {
        if (player.getProduction(Resources_1.Resources.ENERGY) < 1)
            return false;
        if (player.game.board.getAvailableSpacesForCity(player).length === 0)
            return false;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.MARS)) {
            return turmoil.canPlay(player, PartyName_1.PartyName.MARS);
        }
        return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
    }
    play(player) {
        const game = player.game;
        return new SelectSpace_1.SelectSpace('Select space for city tile', game.board.getAvailableSpacesForCity(player), TileType_1.TileType.CITY, (space) => {
            player.addProduction(Resources_1.Resources.ENERGY, -1);
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                game.addCityTile(player, space.id);
                for (let i = 0; i < 2; i++) {
                    game.grantSpaceBonuses(player, space);
                }
                if (space.bonus.includes(SpaceBonus_1.SpaceBonus.OCEAN)) {
                    if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
                        game.defer(new DeferredAction_1.DeferredAction(player, () => {
                            game.deferredActions.runNext();
                            let actionDetails = new RedsPolicy_1.ActionDetails({ cost: constants_1.HELLAS_BONUS_OCEAN_COST, oceansToPlace: 1 });
                            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
                            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
                            }
                            if (this.howToAffordReds.canAfford) {
                                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                    player.howToAffordReds = this.howToAffordReds;
                                    HellasBoard_1.HellasBoard.handleBonusOceanFromTilePlacement(game, player, space);
                                    game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                        game.deferredActions.runNext();
                                        let actionDetails = new RedsPolicy_1.ActionDetails({ cost: constants_1.HELLAS_BONUS_OCEAN_COST, oceansToPlace: 1 });
                                        this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
                                        if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                                            this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
                                        }
                                        if (this.howToAffordReds.canAfford) {
                                            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                                player.howToAffordReds = this.howToAffordReds;
                                                HellasBoard_1.HellasBoard.handleBonusOceanFromTilePlacement(game, player, space);
                                                return undefined;
                                            }));
                                        }
                                        return undefined;
                                    }));
                                    return undefined;
                                }));
                            }
                            return undefined;
                        }));
                    }
                    else {
                        if (player.canAfford(constants_1.HELLAS_BONUS_OCEAN_COST)) {
                            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                HellasBoard_1.HellasBoard.handleBonusOceanFromTilePlacement(game, player, space);
                                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                    if (player.canAfford(constants_1.HELLAS_BONUS_OCEAN_COST)) {
                                        game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                            HellasBoard_1.HellasBoard.handleBonusOceanFromTilePlacement(game, player, space);
                                            return undefined;
                                        }));
                                    }
                                    return undefined;
                                }));
                                return undefined;
                            }));
                        }
                        return undefined;
                    }
                }
                if (space.bonus.includes(SpaceBonus_1.SpaceBonus.TEMPERATURE)) {
                    if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
                        game.defer(new DeferredAction_1.DeferredAction(player, () => {
                            game.deferredActions.runNext();
                            let actionDetails = new RedsPolicy_1.ActionDetails({ cost: constants_1.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST });
                            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
                            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
                            }
                            if (this.howToAffordReds.canAfford) {
                                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                    player.howToAffordReds = this.howToAffordReds;
                                    VastitasBorealisBoard_1.VastitasBorealisBoard.handleBonusTemperatureFromTilePlacement(game, player, space);
                                    game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                        game.deferredActions.runNext();
                                        let actionDetails = new RedsPolicy_1.ActionDetails({ cost: constants_1.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST });
                                        this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
                                        if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                                            this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
                                        }
                                        if (this.howToAffordReds.canAfford) {
                                            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                                player.howToAffordReds = this.howToAffordReds;
                                                VastitasBorealisBoard_1.VastitasBorealisBoard.handleBonusTemperatureFromTilePlacement(game, player, space);
                                                return undefined;
                                            }));
                                        }
                                        return undefined;
                                    }));
                                    return undefined;
                                }));
                            }
                            return undefined;
                        }));
                    }
                    else {
                        if (player.canAfford(constants_1.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST)) {
                            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                VastitasBorealisBoard_1.VastitasBorealisBoard.handleBonusTemperatureFromTilePlacement(game, player, space);
                                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                    if (player.canAfford(constants_1.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST)) {
                                        game.defer(new DeferredAction_1.DeferredAction(player, () => {
                                            VastitasBorealisBoard_1.VastitasBorealisBoard.handleBonusTemperatureFromTilePlacement(game, player, space);
                                            return undefined;
                                        }));
                                    }
                                    return undefined;
                                }));
                                return undefined;
                            }));
                        }
                        return undefined;
                    }
                }
                return undefined;
            }));
            return undefined;
        });
    }
}
exports.FrontierTown = FrontierTown;
//# sourceMappingURL=FrontierTown.js.map